import { useQuery } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useGetCaseExpertKey = 'get-case-expert';

export const useCaseExpertFetch = (id?: string) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: [useGetCaseExpertKey, id],
        queryFn: async ({ queryKey }) => {
            const [, caseExpertGuid] = queryKey;
            const response = await zoneApiClient.getCaseExpertById(caseExpertGuid ?? '');

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve this case expert.');
            }
            return response.payload;
        },
        enabled: !!id,
    });
}
